export const openAddressOnMap = ({ name, address }) => {
  const { street, city, state, zipcode } = address;

  const formattedAddress = `${name}, ${street}, ${city}, ${state}, ${zipcode}`;

  const googleMapsUri = `https://www.google.com/maps?q=${encodeURIComponent(formattedAddress)}`;

  return googleMapsUri;
  // window.open(googleMapsUri, "_blank");
};
